import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <span>&copy; 2026 Edwin Chacko</span>
      <span>Personal React Portfolio</span>
    </footer>
  );
}

export default Footer;